import getBiRewardsGroup from 'services/api/beautyInsider/getBiRewardsGroup';
import BIApi from 'services/api/beautyInsider';
import UtilActions from 'utils/redux/Actions';
import Storage from 'utils/localStorage/Storage';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import store from 'store/Store';
import rougeExclusiveUtils from 'utils/rougeExclusive';
import helpers from 'utils/Helpers';
import { isCreativeRefreshPhase2Enabled } from 'utils/BeautyInsider';

const isObject = helpers.isObject;

function fetchProfileRewards() {
    return dispatch => {
        const config = { filterOutOfStock: isCreativeRefreshPhase2Enabled() };

        getBiRewardsGroup.getBiRewardsGroupForCheckout(config).then(data => {
            const { basket } = store.getState();
            const updatedSkus = {
                ...data,
                biRewardGroups: {}
            };

            isObject(data?.biRewardGroups) &&
                Object.keys(data.biRewardGroups).length > 0 &&
                Object.keys(data.biRewardGroups).forEach(key => {
                    updatedSkus.biRewardGroups[key] = rougeExclusiveUtils.updateRougeExclusiveSkus(data.biRewardGroups[key], basket);
                });

            return dispatch(UtilActions.merge('rewards', 'rewards', updatedSkus));
        });
    };
}

function fetchRecentlyRedeemedRewards(userId, options) {
    return async dispatch => {
        dispatch(UtilActions.merge('rewards', 'rewardsPurchasedGroupsLoading', true));
        dispatch(UtilActions.merge('rewards', 'rewardsPurchasedGroupsError', false));

        try {
            const data = await BIApi.getPurchaseHistory(userId, options);
            const purchasedGroups = Array.isArray(data.purchasedGroups) ? data.purchasedGroups : [];

            Storage.local.setItem(LOCAL_STORAGE.REWARDS_PURCHASED_GROUPS, purchasedGroups);
            dispatch(UtilActions.merge('rewards', 'rewardsPurchasedGroups', purchasedGroups));
        } catch (error) {
            dispatch(UtilActions.merge('rewards', 'rewardsPurchasedGroupsError', true));
            Sephora.logger.error('RewardActions: failed to fetch recently redeemed rewards', error);
        } finally {
            dispatch(UtilActions.merge('rewards', 'rewardsPurchasedGroupsLoading', false));
        }
    };
}

export default {
    fetchProfileRewards,
    fetchRecentlyRedeemedRewards
};
